import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Button } from '../ui/button';

const AssetContainer = () => {
  // Simple navigation buttons replicating Angular asset.component.html
  const links = [
    { to: '/assetpage/inverter', label: 'Inverter' },
    { to: '/assetpage/weathersensor', label: 'Soiling Station' },
    // Future buttons: tracker, transformer, summary etc
  ];

  return (
    <div className="space-y-6 p-6">
      <div className="flex flex-wrap gap-3 mb-6">
        {links.map(link => (
          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) =>
              `custom-button inline-flex items-center justify-center px-4 py-2 rounded-md border text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 ${
                isActive
                  ? 'bg-blue-600 text-white hover:bg-blue-700'
                  : 'bg-muted hover:bg-gray-200 dark:hover:bg-gray-700'
              }`}
          >
            {link.label}
          </NavLink>
        ))}
      </div>
      <Outlet />
    </div>
  );
};

export default AssetContainer;
